<h3 class="title-divider">{{ heading | translate }}</h3>
<cap-form-control labelKey="Dienstbarkeit">
  <input
    (ngModelChange)="model && (model.sucheDienstbarkeit = $event)"
    [ngModel]="model && model.sucheDienstbarkeit"
    name="RechteSelection.sucheDienstbarkeit"
    type="checkbox" />
</cap-form-control>
<cap-form-control labelKey="Vormerkung">
  <input
    (ngModelChange)="model && (model.sucheVormerkung = $event)"
    [ngModel]="model && model.sucheVormerkung"
    name="RechteSelection.sucheVormerkung"
    type="checkbox" />
</cap-form-control>
<cap-form-control labelKey="Grundlast">
  <input
    (ngModelChange)="model && (model.sucheGrundlast = $event)"
    [ngModel]="model && model.sucheGrundlast"
    name="RechteSelection.sucheGrundlast"
    type="checkbox" />
</cap-form-control>
<cap-form-control labelKey="Anmerkung">
  <input
    (ngModelChange)="model && (model.sucheAnmerkung = $event)"
    [ngModel]="model && model.sucheAnmerkung"
    name="RechteSelection.sucheAnmerkung"
    type="checkbox" />
</cap-form-control>
<cap-form-control labelKey="SelbstständigesUndDauerndesRecht">
  <input
    (ngModelChange)="model && (model.sucheSDR = $event)"
    [ngModel]="model && model.sucheSDR"
    name="RechteSelection.sucheSDR"
    type="checkbox" />
</cap-form-control>
@if (showArtGrundpfandrecht) {
  <cap-form-control labelKey="Grundpfandrecht">
    <input
      (ngModelChange)="model && (model.sucheGrundpfandrecht = $event)"
      [ngModel]="model && model.sucheGrundpfandrecht"
      name="RechteSelection.sucheGrundpfandrecht"
      type="checkbox" />
  </cap-form-control>
}
